import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=0c81f1c8"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTab.vue?vue&type=style&index=0&id=0c81f1c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports